import ElectronicKeyModelTypes from 'store/actionTypes/electronicKeyModel'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {}
}

const electronicKeyModel = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ElectronicKeyModelTypes.GET_ELECTRONIC_KEY_MODELS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ElectronicKeyModelTypes.GET_ELECTRONIC_KEY_MODEL_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case ElectronicKeyModelTypes.UPDATE_FILTER_ELECTRONIC_KEY_MODEL_SUCCESS:
      return { ...state, filter: payload }
    case ElectronicKeyModelTypes.CLEAR_FILTER_ELECTRONIC_KEY_MODEL_SUCCESS:
      return { ...state, filter: initialData.filter }
    case ElectronicKeyModelTypes.GET_SYSTEM_ELECTRONIC_KEY_MODELS_SUCCESS:
      return { ...state, systems: payload?.electronicKeyModel?.items }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default electronicKeyModel
